export const PIP_QUESTIONS = [
  'What is the warranty on this item?',
  'What are the delivery options for this item?',
  'What do I need to know before using it?',
  'What do I need to know before I buy?',
  'What are the key features?',
  'What are the top uses for this product?',
  'Can this item be returned or exchanged?',
  'What are the key specifications?',
  'How soon can I get this delivered to my zip code?',
  'What is the delivery charge for this item?',
];